import {
  type ContextType,
  type Dispatch,
  type FC,
  type PropsWithChildren,
  type SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

type DrawerState =
  | { open: false }
  | { open: true; operation: 'create' }
  | {
      open: true;
      operation: 'update';
      templateId: string;
      organizationIds: string[];
    };

const Context = createContext<
  | {
      drawerState: DrawerState;
      setDrawerState: Dispatch<SetStateAction<DrawerState>>;
    }
  | undefined
>(undefined);

export const useWorkflowTemplateDrawerState = (): NonNullable<
  ContextType<typeof Context>
> => {
  const context = useContext(Context);
  if (!context) {
    throw new Error(
      'useWorkflowTemplateDrawerState must be used within WorkflowTemplateDrawerStateProvider.',
    );
  }
  return context;
};

export const WorkflowTemplateDrawerStateProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const [drawerState, setDrawerState] = useState<DrawerState>({ open: false });

  return (
    <Context.Provider value={{ drawerState, setDrawerState }}>
      {children}
    </Context.Provider>
  );
};
